/* eslint-disable import/no-anonymous-default-export */
import { UserList } from './UserList';
import { UserEdit } from './UserEdit';
import { UserCreate } from './UserCreate';

export default {
    list: UserList,
    create: UserCreate,
    edit: UserEdit
};